import * as React from "react";

// statically loaded preloader
export default <div>Loading...</div>;
